export const FETCH_MOVIE_DETAIL_REQUEST = 'FETCH_MOVIE_DETAIL_REQUEST'
export const FETCH_MOVIE_DETAIL_SUCCESS = 'FETCH_MOVIE_DETAIL_SUCCESS'
export const FETCH_MOVIE_DETAIL_FAILURE = 'FETCH_MOVIE_DETAIL_FAILURE'